<template>
  <div class="card relative" v-loading="loading" @click="getData(solution)">
    <img class="pic" :src="solution.cover_img" :alt="solution.title" @click="open" />
    <div class="content ">
      <div class="  w-90 con">
        <div class="title ellipsis fw-n">
          {{ solution.title }}
        </div>
        <div class="infos fw-n">
          {{ $t("card.p1") }}：{{ region_name }}
          {{ $t("card.p2") }}：{{ solution.area
          }}㎡
        </div>
      </div>
      <!-- <div style="margin-top: 28px; display: flex">
        <span @click="star(solution.id)"><el-icon class="star"
            :class="it ? 'active el-icon-star-on sta' : 'el-icon-star-off '"></el-icon></span>

      </div> -->
    </div>
  </div>
</template>

<script>
// import { getCookies } from "@/assets/js/cookies.js";

import getAreas from "../assets/area";
export default {
  data() {
    return {
      region_name: '',
      flag: true,
      loading: false,
      defautlurl: 'https://external.333f.com/333f-2021-api/public/storage/'
    };
  },
  name: "solutionCard",
  props: {
    solution: Object,
    it: Boolean,
    id: Number,
  },
  mounted() {
    let areas = getAreas()
    for (let i = 0; i < areas.length; i++) {
      if (Number(areas[i].code) == this.solution.region) {
        this.region_name = areas[i].name
        break
      }
    }
  },
  methods: {
    getData(item) {
      if (item.attachment) {

        // window.open(item.attachment, '_blank')
        let name = decodeURIComponent(item.attachment.split('/').pop())
        this.downloadFile(item.attachment, name)
      }
    },
    star(id) {
      // let token = getCookies("token") || false;
      // if (!token) {
      //   this.$message({
      //     message: this.$t("card.p4"),
      //     type: "warning",
      //   });
      //   return false;
      // }

      // if (this.flag) {
      //   this.flag = false;
      //   if (!this.it) {
      //     this.$http.post("/api/solution/star/" + id).then((res) => {
      //       if (res.code == 200) {
      //         this.$emit("genxin", new Date());
      //         this.$message({
      //           message: this.$t("card.p5"),
      //           type: "success",
      //         });
      //       }
      //     });
      //     this.flag = true;
      //   } else {
      //     this.$http.deletes("/api/solution/star/" + id).then((res) => {
      //       if (res.code == 200) {
      //         this.$emit("genxin", new Date());
      //         this.$message({
      //           message: this.$t("card.p6"),
      //           type: "success",
      //         });
      //       }
      //       this.flag = true;
      //     });
      //   }
      // }
    },
    download(id, name) {
      // this.loading = true;
      // this.$http.getFile("/api/solution/download/" + id).then((res) => {
      //   this.loading = false;
      //   let src = res;
      // this.downloadFile(src, name); //地址，文件名
      // });
    },

    downloadFile(data, fileName) {
      if (!data) {
        return;
      }
      let that = this
      this.loading = true
      const isIE = !!window.ActiveXObject || "ActiveXObject" in window;

      var xhr = new XMLHttpRequest();
      xhr.open("GET", data, true);
      if (isIE) {

        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            // 兼容 IE10+
            if (window.navigator.msSaveBlob) {
              const blob = new Blob([xhr.response], {
                type: 'application/octet-stream'
              });
              window.navigator.msSaveBlob(blob, fileName);
            }
          } else {
            that.$message({
              message: '下载失败，请稍后重试',
              type: 'error'
            });
          }
          // this.loading = false;
        };
        xhr.onerror = () => {
          that.$message({
            message: '下载失败，请稍后重试',
            type: 'error'
          });
          // this.loading = false;
        };
        setTimeout(() => {
          that.loading = false;
        }, 2000);
      } else {
        fetch(data)
          .then(response => response.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            that.loading = false;
          })
          .catch(err => {
            console.error('Download failed:', err);
            that.$message({
              message: '下载失败，请稍后重试',
              type: 'error'
            });
            that.loading = false;
          });
      }
      xhr.send();

    },
    open() {
      // let token = getCookies("token") || false;
      // if (!token) {
      //   this.$message({
      //     message: this.$t("card.p4"),
      //     type: "warning",
      //   });
      //   return false;
      // }
      // this.$router.push({
      //   path: `/info/${this.id}`,
      //   params: {
      //     id: this.id,
      //   },
      // });
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  overflow: hidden;
  box-shadow: 0 0 15px #e9e9e9;
  border-radius: 9px;
  margin: 0 0 20px 0;
  padding-bottom: 90px;
}

.pic {
  width: 100%;
  max-height: 300px;
  height: auto;
}

.content {
  padding: 16px 0 0 0;
  width: 98%;
  min-height: 80px;
  position: relative;
  position: absolute;
  bottom: 14px;
  left: 10px;

  .con {}
}

.title {
  font-size: 20px;
  color: @text-title-ZH-color;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.infos {
  margin-top: 5px;
  font-size: 16px;
  color: @text-title-ZH-color;
  white-space: nowrap;
}

.star {
  // width: 16px;
  // height: 16px;
  font-size: 25px;
  margin-right: 14px;
}

.sta {
  font-size: 25px;
}

.active {
  color: red;
}

.download {
  width: 14px;
  height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/solutionCard.vue